import { get } from 'lodash-es';
import { CONDITIONS } from 'site-modules/shared/constants/appraisal/appraisal';
import { ESTIMATED_VALUES_CONDITION } from './estimated-values-constants';

export const isEstimatedTmvConditions = appraisalStyle => {
  const tmvConditions = Object.keys(get(appraisalStyle, 'tmv.conditions', {}));
  return tmvConditions.some(tmvCondition => ESTIMATED_VALUES_CONDITION.includes(CONDITIONS[tmvCondition]));
};
